import { render } from "./WMGrid.vue?vue&type=template&id=537b23ee"
import script from "./WMGrid.vue?vue&type=script&lang=js"
export * from "./WMGrid.vue?vue&type=script&lang=js"

import "./WMGrid.vue?vue&type=style&index=0&id=537b23ee&media=screen&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__